/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import AssessmentLevelContainer from './assessment-level/container/AssessmentLevelContainer';
import DepreciationRateContainer from './depreciation-rates/container/DepreciationRateContainer';
import ListOfMachineryContainer from './list-of-machinery/container/ListOfMachineryContainer';
import TaxCreditContainer from './tax-credit/container/TaxCreditContainer';

function MachinerySettingsRoutes({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row custom-nav-links">
            <ul className="nav nav-tabs tab-container">
              {Acl(permissions, [
                'VIEW E2E RPT MACHINERY ASSESSMENT LEVELS',
              ]) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/machinery-settings/assessment-level"
                    className={`nav-link per-tab ${
                      pathName.indexOf(
                        'rpt/machinery/machinery-settings/assessment-level'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Assessment Level
                  </Link>
                </li>
              )}
              {Acl(permissions, [
                'VIEW E2E RPT MACHINERY DEPRECIATION RATES',
              ]) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/machinery-settings/depreciation-rates"
                    className={`nav-link per-tab ${
                      pathName.indexOf(
                        'rpt/machinery/machinery-settings/depreciation-rates'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Depreciation Rates
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW E2E RPT MACHINERY MACHINES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/machinery-settings/list-of-machinery"
                    className={`nav-link per-tab ${
                      pathName.indexOf(
                        'rpt/machinery/machinery-settings/list-of-machinery'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    List of Machinery
                  </Link>
                </li>
              )}
              {/* {Acl(permissions, ['VIEW E2E RPT MACHINERY MACHINES']) && ( */}
              <li className="nav-item">
                <Link
                  to="/rpt/machinery/machinery-settings/tax-credit"
                  className={`nav-link per-tab ${
                    pathName.indexOf(
                      'rpt/machinery/machinery-settings/tax-credit'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Tax Credit
                </Link>
              </li>
              {/* )} */}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, [
            'E2E RPT MACHINERY SETTINGS ASSESSMENT LEVEL',
          ]) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/assessment-level`} />}
            />
          )}
          {Acl(permissions, ['VIEW E2E RPT MACHINERY ASSESSMENT LEVELS']) && (
            <Route
              path={`${match.path}/assessment-level`}
              component={AssessmentLevelContainer}
            />
          )}
          {Acl(permissions, ['VIEW E2E RPT MACHINERY DEPRECIATION RATES']) && (
            <Route
              path={`${match.path}/depreciation-rates`}
              component={DepreciationRateContainer}
            />
          )}
          {Acl(permissions, ['VIEW E2E RPT MACHINERY MACHINES']) && (
            <Route
              path={`${match.path}/list-of-machinery`}
              component={ListOfMachineryContainer}
            />
          )}
          {/* {Acl(permissions, ['VIEW E2E RPT MACHINERY MACHINES']) && ( */}
          <Route
            path={`${match.path}/tax-credit`}
            component={TaxCreditContainer}
          />
          {/* )} */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

MachinerySettingsRoutes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MachinerySettingsRoutes);
